import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

    static get targets() {
        return ["category","keyword","table"];
    }

    static get values() {
        return {
            "dataUrl": String
        }
    }

    categoryChangedHandler({ currentTarget, params: { columnIndex } }) {
        var selectedValue = currentTarget.options[currentTarget.selectedIndex].value;
        this.tableTarget.datatable.columns(columnIndex).search(selectedValue).draw();
    }

    keywordChangedHandler({ target }) {
        this.tableTarget.datatable.search(target.value).draw();
    }

    async connect() {
        if (!this.tableTarget.datatable) {
            const { DataTable } = await import("imports/datatables");
            this.tableTarget.datatable = new DataTable(this.tableTarget, {
                dom: "<'row dt-row'<'col-sm-12'tr>><'row'<'col-sm-12 d-flex justify-content-center'p>>",
                pageLength: 25,
                ordering: false,
                retrieve: true,
                ajax: {
                    url: this.dataUrlValue
                },
                processing: false,
                serverSide: true,
                columnDefs: [
                    {
                        targets: 0,
                        data: "sku",
                    },
                    {
                        targets: 1,
                        data: "category",
                    },
                    {
                        targets: 2,
                        data: "name",
                    },
                    {
                        targets: 3,
                        data: "points",
                    }
                ]
            });
        }
    //    if (!this.tableTarget.datatable) {
    //        const { DataTable } = await import("imports/datatables");
    //        this.tableTarget.datatable = new DataTable(this.tableTarget, {
    //            dom: "<'row dt-row'<'col-sm-12'tr>><'row'<'col-sm-12 d-flex justify-content-center'p>>",
    //            pageLength: 50,
    //            columnDefs: [
    //                {type: 'natural', targets: 0}
    //            ]
    //        });
    //    }
    }
}